import { useQuery } from '@tanstack/react-query';
import { fetchAnalyticsSummary, type AnalyticsSummaryRequest, type AnalyticsSummaryResponse } from '@/utils/analyticsSummaryAPI';

export function useAnalyticsSummary(request: AnalyticsSummaryRequest | null) {
  return useQuery<AnalyticsSummaryResponse, Error>({
    queryKey: ['analyticsSummary', request],
    queryFn: () => {
      if (!request) {
        throw new Error('Request is required');
      }
      return fetchAnalyticsSummary(request);
    },
    enabled: !!request,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
  });
}
